import React, { FC } from 'react';
import BusinessDetailItem from '../DetailItem/BusinessDetailItem';
import { IBusiness } from '../utils/utils';
import CustomAccordion from '../../../common/components/CustomAccordion/CustomAccordion';
import { Grid } from '@material-ui/core';

interface Params {
  businessState: IBusiness;
  setBusinessState: React.Dispatch<React.SetStateAction<IBusiness>>;
  canEditBusiness: boolean;
}

const BusinessCoordonnees: FC<Params> = (props) => {
  const { businessState, setBusinessState, canEditBusiness } = props;

  return (
    <CustomAccordion title="Coordonnées client">
      <Grid container>
        <BusinessDetailItem
          mutationVariableName="lastName"
          label="Nom"
          value={businessState.lastName}
          editable={canEditBusiness}
          setBusinessState={setBusinessState}
        />
        <BusinessDetailItem
          mutationVariableName="firstName"
          label="Prénom"
          value={businessState.firstName}
          editable={canEditBusiness}
          setBusinessState={setBusinessState}
        />
        <BusinessDetailItem
          mutationVariableName="phone"
          label="Téléphone"
          value={businessState.phone}
          editable={canEditBusiness}
          setBusinessState={setBusinessState}
        />
        <BusinessDetailItem
          mutationVariableName="email"
          label="Email"
          value={businessState.email}
          editable={canEditBusiness}
          setBusinessState={setBusinessState}
        />
      </Grid>
    </CustomAccordion>
  );
};

export default BusinessCoordonnees;
